import marked from "marked";

export function markdownFormatWithoutPTags(text) {
  let formattedContent = marked(text);
  formattedContent = formattedContent.replace('<p>', '');
  formattedContent = formattedContent.replace('</p>', '');
  
  return formattedContent;
};